module.exports = __webpack_public_path__ + "img/PTI_LIMPIEZA.8fd7941b.png";